import { Children, isValidElement, cloneElement } from 'react';
const isProduction = () => process.env.NODE_ENV === 'production';
function warnOnPropsOverlap(parentProps, childProps) {
  const setParent = new Set(Object.keys(parentProps));
  const setChild = new Set(Object.keys(childProps));
  const overlap = [...setParent].filter(x => setChild.has(x));
  overlap.forEach(prop => {
    // eslint-disable-next-line no-console
    console.warn(`Prop ${prop} should not be passed to child component, it is inferred from the parent`);
  });
}
const cloneAndMergeParentProps = (props, parentProps) => {
  if (!isProduction()) {
    warnOnPropsOverlap(parentProps, props);
  }
  return Object.assign({}, props, parentProps);
};
const cloneElementWithProps = ({
  child,
  newProps = {}
}) => {
  if ( /*#__PURE__*/isValidElement(child)) {
    const cloneProps = cloneAndMergeParentProps(child.props, newProps);
    return /*#__PURE__*/cloneElement(child, cloneProps);
  } else {
    return null;
  }
};
export const cloneChildren = ({
  children,
  newProps
}) => Children.map(children, child => cloneElementWithProps({
  child,
  newProps
}));